import script from "./PhotoEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./PhotoEditor.vue?vue&type=script&setup=true&lang=js"

import "./PhotoEditor.vue?vue&type=style&index=0&id=777add0f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-777add0f"]])

export default __exports__